import { ChatState, ChatMessagePayload } from 'features/chat/types';
import { flatToGrouped } from 'features/chat/utils/flatToGrouped';
import { getPrivateChatSenderId } from 'features/chat/utils/getPrivateChatSenderId';
import { getPrivateChatTarget } from 'features/chat/utils/getPrivateChatTarget';

export const processMessage = (state: ChatState, message: ChatMessagePayload) => {
  const { entities, senders, privateChat, localUserId, localUserExternalId, publicIds } = state;
  const { id, user, privateGroup, targetUser, date } = message;

  const isAlreadyExists = !!entities[id];

  entities[id] = {
    ...message,
    // An optimistic image message may be confirmed by a payload that does not
    // echo the images (e.g. they are still processing); keep the ones already
    // rendered locally instead of blanking the message.
    images: message.images ?? entities[id]?.images,
    reply: message.reply ?? entities[id]?.reply,
    parentId: message.parentId ?? entities[id]?.parentId,
    reactions: flatToGrouped(message.reactions, localUserId, localUserExternalId),
  };

  const key = getPrivateChatSenderId(user);
  senders[key] = user;

  if (privateGroup) {
    const targetId = state.privateChat.groupChat.id;
    const chatToUpdate = privateChat.chats[targetId] || {
      lastActivity: null,
      group: null,
      messages: [],
    };

    chatToUpdate.lastActivity = date;
    chatToUpdate.group = privateGroup;

    if (!isAlreadyExists) {
      chatToUpdate.messages.push(id);
    }

    privateChat.chats[targetId] = chatToUpdate;
  } else if (targetUser) {
    const { targetChatId, isLocalTarget, chatTargetUser } = getPrivateChatTarget({
      localUserId,
      localUserExternalId,
      user,
      targetUser,
    });

    const chatToUpdate = privateChat.chats[targetChatId] || {
      lastActivity: null,
      messages: [],
    };

    chatToUpdate.lastActivity = date;
    chatToUpdate.externalId = chatTargetUser.externalId;

    if (!isAlreadyExists) {
      chatToUpdate.messages.push(id);
    }

    privateChat.chats[targetChatId] = chatToUpdate;

    if (!isLocalTarget) {
      senders[targetChatId] = chatTargetUser;
    }
  } else if (!isAlreadyExists) {
    publicIds.push(id);
  }
};
